"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const identifiers_1 = require("./identifiers");
const WrappedContent_1 = require("./common/WrappedContent");
function getContent(query) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = `${identifiers_1.Types.BACKEND_URL}/getContent`;
            const urlResponse = yield fetch(url, {
                body: JSON.stringify(query),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                }
            });
            const responseJSON = yield urlResponse.json();
            const allWrappedContent = [];
            responseJSON.data.forEach(data => {
                const content = new WrappedContent_1.default(data);
                allWrappedContent.push(content);
            });
            return allWrappedContent;
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = getContent;
//# sourceMappingURL=getContent.js.map